import React, { useEffect, useState } from "reactn";
import { useParams, useHistory } from 'react-router-dom'
import { Table, Button, Modal, Card, Row, Form, Col, List } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, getDoc, collection, getDocs, query, where, onSnapshot } from 'firebase/firestore';
import { Loading3QuartersOutlined, LeftOutlined, AudioOutlined, AudioMutedOutlined, CloseOutlined, EyeOutlined, EyeInvisibleOutlined, VideoCameraOutlined, SyncOutlined } from "@ant-design/icons";
import axios from 'axios';

const StreamControl = (props) => {
    let params = useParams()
    let id = params.id !== "add" ? params.id : false;
    let [data, setData] = useState([]);
    let [stream, setStream] = useState(null);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);
    let [modalData, setModalData] = useState(null);
    let [change, setChange] = useState(null);

    const history = useHistory();
    let handleTableChange = async (page, filters, sorter) => {
        if (stream) {
            get(page, filters, sorter);
        }
    }

    let getStream = async () => {
        const streamRef = doc(firebaseDb, "stream", id);
        const streamSnap = await getDoc(streamRef);

        if (streamSnap.exists()) {
            setStream({
                ...streamSnap.data(),
                id: streamSnap.id
            });
        }
    }

    let get = async () => {
        if (stream) {
            let userRef = collection(firebaseDb, "users")
            const userQuery = query(userRef, where("streamId", "==", stream.sessionId));
            const docsSnap = await getDocs(userQuery);
            let datas = []
            for (const document of docsSnap.docs) {
                datas.push({ id: document.id, ...document.data() })
            }
            console.log(datas);

            realTime()
            setData(datas);
            setTotalCount(datas.length);
            setLoading(false)
        }
    }

    let realTime = async () => {
        let userRef = collection(firebaseDb, "users")
        const userQuery = query(userRef, where("streamId", "==", stream.sessionId));
        // onSnapshot(userQuery, (snapshot) => {
        //     snapshot.docChanges().forEach(async (change) => {
        //         if (change.type === "added") {
        //             setChange("added");
        //         }
        //         if (change.type === "modified") {
        //             setChange("modified");
        //         }
        //         if (change.type === "removed") {
        //             setChange("removed");
        //         }
        //     });
        // });
        onSnapshot(userQuery, (snapshot) => {
            let updatedData = [];

            snapshot.forEach((doc) => {
                updatedData.push({ id: doc.id, ...doc.data() });
            });

            setData(updatedData); // update the data state with new snapshot
            setTotalCount(updatedData.length);
            setLoading(false);

            // Optional: you can still track what changed
            snapshot.docChanges().forEach((change) => {
                if (change.type === "added") setChange("added");
                if (change.type === "modified") setChange("modified");
                if (change.type === "removed") setChange("removed");
            });
        });
    }

    useEffect(() => {
        setLoading(true)
        getStream();
    }, [])

    useEffect(() => {
        console.log({ change })
        setLoading(true)
        get()
    }, [change])

    useEffect(() => {
        if (stream) {
            get();
        }
    }, [stream])

    let disconnect = async (data) => {
        const article = { sessionId: stream.sessionId, connectionId: data.connectionId };
        await axios.post("https://futurelive-api.eventapp.app/rest/disconnect", article).then(resp => {
        });
        getStream()
    }
    let mute = async (data) => {
        const article = { sessionId: stream.sessionId, streamId: data.streamId };
        await axios.post("https://futurelive-api.eventapp.app/rest/mute", article).then(resp => {
        });
        getStream()
    }
    useEffect(() => {
        if (stream) {
            realTime();
        }
    }, [stream]);
    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'profileImageUrl',
            key: 'profileImageUrl',
            width: 50,
            render: (profileImageUrl, record) => {
                return (
                    <div style={{ width: '100px' }}>
                        <img src={profileImageUrl ? profileImageUrl : "https://futurelive-api.eventapp.app/files/avatar.png"} style={{ width: '100%' }} />
                    </div>
                )
            }
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
            width: 50,
        },
        {
            title: 'Soyadı',
            dataIndex: 'surname',
            key: 'surname',
            width: 50,
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 200,
            render: (text, record) => (
                <Row className="gap-8" size="small">
                    <Link>
                        <Button onClick={() => disconnect(record)} type="danger" className="button4" icon={<CloseOutlined />}>Çıkart</Button>
                    </Link>
                    <Link>
                        <Button onClick={() => mute(record)} className="button-consultant" icon={<AudioOutlined />}>Ses</Button>
                    </Link>
                    <Link >
                        <Button className="button-consultant" icon={<VideoCameraOutlined />}>Kamera</Button>
                    </Link>
                </Row>
            )
        }
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Canlı Yayın Kontrol"} </h1>
                    <h6>{stream ? stream.name : ""}</h6>
                </div>
                <div className="list-buttons div-buttons">
                    <Button className="button4" type="light" onClick={() => {
                        realTime()
                        handleTableChange()
                    }} icon={<SyncOutlined />} size="large">Yenile</Button>
                    <Link to="/streams">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
            {modalData &&
                <div>
                    <Modal
                        visible={true}
                        onOk={() => setModalData(null)}
                        onCancel={() => setModalData(null)}>
                        <Card loading={modalData ? false : true} >
                            <Form>
                                <Row direction="row">
                                    <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                        <Form.Item>
                                            <List
                                                itemLayout="horizontal"
                                                dataSource={modalData}
                                                renderItem={item => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            title={<a>{item}</a>}
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <p>Belirtilen kodlar zaten kullanılıyor. Limit artırımı için düzenleme işlemi yapınız!</p>
                                </Row>
                            </Form>
                        </Card>
                    </Modal>
                </div>
            }
        </div>
    );
};

export default StreamControl;
